import { LinkCategory } from 'src/containers/ProjectDiagram/constants/categories';
import {
  DeletedMapping,
  Mapping,
} from 'src/containers/ProjectDiagram/types/data';
import { replaceDeletedMappingLabelKey } from 'src/containers/ProjectDiagram/utils/mapping/createDeletedMappingLabel';
import { replaceDeletedModelConceptClassKey } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createDeletedModelConceptClass';
import { replaceDeletedResourceKey } from 'src/containers/ProjectDiagram/utils/resource/createDeletedResource';

export const replaceDeletedMappingKey = (key: string) =>
  key.replace(
    new RegExp(`^${LinkCategory.MAPPING}-`),
    `${LinkCategory.DELETED_MAPPING}-`
  );

export const createDeletedMapping = (
  existing: Mapping,
  deletedKeys: Set<string>
): DeletedMapping => ({
  key: replaceDeletedMappingKey(existing.key),
  from: deletedKeys.has(existing.from)
    ? replaceDeletedResourceKey(existing.from)
    : existing.from,
  value: existing.value,
  text: existing.text,
  to:
    existing.to && deletedKeys.has(existing.to)
      ? replaceDeletedModelConceptClassKey(existing.to)
      : existing.to,
  labelKeys: existing.labelKeys.map(replaceDeletedMappingLabelKey),
  category: LinkCategory.DELETED_MAPPING,
  points: existing.points,
});
